import * as React from 'react';
import {FruitBoxView} from "src/components/view/FruitBoxView";
import {IChangeContainerPayload, IChangeDraggingElementPayload} from "src/store/actions";
import {IBoxes, IDraggingElement, IFruits, IShelves} from "src/store/models";
import {cancelEvent} from "src/utils/utils";
import {SortFruitsOnShelf} from './SortFruitsOnShelf';

interface IProps {
    boxes: IBoxes;
    fruits: IFruits;
    shelves: IShelves;
    shelfId: string;
    draggingElement: IDraggingElement;
    move: (payload: IChangeContainerPayload) => void;
    drag: (payload: IChangeDraggingElementPayload) => void;
}

interface IState {
    isDroppable: boolean;
}

export class FruitShelfView extends React.Component<IProps, IState> {

    public state = {
        isDroppable : false
    };

    public handleDrop = (e: React.DragEvent) => {
        const {move, shelfId, draggingElement} = this.props;
        if (draggingElement.type === 'box') {
            move({elementId: draggingElement.id, targetId: shelfId})
        }
        this.props.drag({id: '', type: ''});
        cancelEvent(e);
        this.setState({isDroppable: false});
    };

    public handleDragOver = (e: React.DragEvent) => {
        if (this.props.draggingElement.type !== 'box') {
            this.setState({isDroppable: false});
            return;
        }
        cancelEvent(e);
        this.setState({isDroppable: true});
    };

    public handleDragLeave = () => {
        this.setState({isDroppable: false})
    };

    public render() {
        const {boxes, fruits, shelves, shelfId, move, draggingElement, drag} = this.props;
        const ids = shelves[shelfId].boxesIds;
        const isEmpty = ids.length <= 0 || ids.every(boxId => boxes[boxId].fruitsIds.length === 0);
        const isEmptyClass = isEmpty ? `FruitShelfView--empty` : '';
        const isDroppableClass = this.state.isDroppable ? `FruitShelfView--droppable` : '';

        return (
            <div
                className={`FruitShelfView ${isEmptyClass} ${isDroppableClass}`}
                onDrop={this.handleDrop}
                onDragEnd={this.handleDrop}
                onDragOver={this.handleDragOver}
                onDragLeave={this.handleDragLeave}
            >
                {!isEmpty && <SortFruitsOnShelf shelfId={shelfId}/>}
                {ids.map(boxId => {
                        const {fruitsIds} = boxes[boxId];
                        return (
                            <FruitBoxView
                                shelfId={shelfId}
                                boxId={boxId}
                                fruits={fruits}
                                fruitsIds={fruitsIds}
                                key={boxId}
                                draggingElement={draggingElement}
                                move={move}
                                drag={drag}
                            />
                        )
                    }
                )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/view/FruitShelfView.tsx